module.exports = "/_next/static/images/61acd58942910461971c889e0bcb6bd8-hands-holding-cards-lg@2x.jpg.webp";